/**
 *  节流
 * @param {*} fn
 * @param {*} delay
 * @returns
 */
export const debounce = function(fn, delay = 500) {
    // 默认500毫秒
    let timer;
    return function() {
        const args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(this, args); // this 指向vue
        }, delay);
    };
};
